var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-down"}},[(_vm.data.time)?_c('div',{staticClass:"notification",class:['notification--' + _vm.data.theme],on:{"click":_vm.reset}},[_c('div',{staticClass:"notification__content"},[_vm._v(_vm._s(_vm.data.content))]),_c('div',{staticClass:"notification__bar"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }